module.exports = __webpack_public_path__ + "static/media/lvl3.92ff18f4.png";